export default __webpack_public_path__ + "static/media/chevron.da7f0b33.svg";